<template>
    <div class="newPage">
        <div class="content">
            <div class='VOCNavBar'>
                <div class="BarList">
                    <template v-for="(item,index) in queryList">
                        <div class="navBarItem" :key="index" v-if="item==='startTime'">
                            <div class="navBarTitle">开始时间</div>

                            <div class="navBarValue">
                                <el-date-picker
                                        v-model="queryParams[item]"
                                        size="mini"
                                        type="datetime"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        placeholder="选择开始时间">
                                </el-date-picker>
                            </div>
                        </div>

                        <div class="navBarItem" :key="index" v-if="item==='endTime'">
                            <div class="navBarTitle">结束时间</div>

                            <div class="navBarValue">
                                <el-date-picker
                                        v-model="queryParams[item]"
                                        size="mini"
                                        type="datetime"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        placeholder="选择结束时间">
                                </el-date-picker>
                            </div>
                        </div>

                        <div class="navBarItem" :key="index" v-if="item==='year'">
                            <div class="navBarTitle">年</div>
                            <div class="navBarValue">
                                <el-date-picker
                                        v-model="queryParams[item]"
                                        type="year"
                                        placeholder="选择年" size="mini" value-format="yyyy">
                                </el-date-picker>
                            </div>
                        </div>

                        <div class="navBarItem" :key="index" v-if="item==='type'">
                            <div class="navBarTitle">类型</div>
                            <div class="navBarValue">
                                <el-select v-model="queryParams[item]" placeholder="请选择" size="mini">
                                    <el-option label="docx" value="docx"></el-option>
                                    <el-option label="pdf" value="pdf"></el-option>
                                </el-select>
                            </div>
                        </div>
                        <div class="navBarItem" :key="index" v-if="item==='dates'">
                            <div class="navBarTitle">时间</div>
                            <div class="navBarValue">
                                <el-date-picker
                                        v-model="queryParams[item]"
                                        size="mini"
                                        type="datetime"
                                        value-format="yyyy-MM-dd HH:mm:ss"
                                        placeholder="选择开始时间">
                                </el-date-picker>
                            </div>
                        </div>

                        <div class="navBarItem" :key="index" v-if="item==='city'">
                            <div class="navBarTitle">城市</div>
                            <div class="navBarValue">
                                <el-cascader
                                        size="mini"
                                        v-model="queryParams[item]"
                                        :options="cityList"
                                        :props="{emitPath:false, checkStrictly: true,label: 'lable',value:'lable'}"
                                        clearable placeholder="请选择城市"></el-cascader>
                            </div>
                        </div>
                    </template>

                </div>

                <div class="btnBox">
                    <el-button type="primary" size="mini" @click="getList">获取</el-button>
                    <!--<el-button type="primary" size="mini" @click="handleOpenDetail">定时任务</el-button>-->
                </div>
            </div>
            <div class="showContent" v-loading="loading">
                <breadcrumb></breadcrumb>
                <div class="VOCContent" v-if="resultObj.resultType==='value'">
                    {{resultObj.value}}
                </div>
                <div class="VOCContent" v-if="resultObj.resultType==='png'">
                    <img :src="resultObj.value" alt="">
                </div>
                <div class="VOCContent" v-if="resultObj.resultType==='pdf'">
                    <pdf v-for="i in pdfPage" :key="i" :src="pdfSrc" :page="i"
                         ref="myPdf"></pdf>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

    import Breadcrumb from "../../components/breadcrumb";
    // import pdf from 'vue-pdf'
    import pdf from '../../components/vue-pdf'
    import CMapReaderFactory from 'vue-pdf/src/CMapReaderFactory.js'

    import url from "../../utils/UrlApi"

    export default {
        name: "VOCchart",
        components: {Breadcrumb, pdf},
        computed: {
            id: {
                get() {
                    return this.$route.query.menuId
                }
            },
            name: {
                get() {
                    return this.$route.query.name
                }
            }
        },
        data() {
            return {
                queryParams: {},
                queryList: [],
                loading: false,
                resultObj: '',
                dialogVisible: false,
                timingForm: {
                    id: '',
                    cron: '',
                    baseTime: '',
                    status: 1
                },
                cityList: [],
                pdfSrc: '',
                pdfPage: 0,
                isClick: 0
            }
        },
        created() {
            this.getQuery()
            this.getCityList()
        },
        methods: {
            init() {
                this.queryParams = {}
                this.resultObj = ''
                this.getQuery()
                // this.getList()
            },
            getList() {
                if (this.isClick === 1) {
                    return
                }

                this.isClick = 1
                let data = this.queryParams
                data.menuId = this.id
                this.pdfPage = 0
                this.pdfSrc = ''
                this.loading  = true

                this.$http.post(url.dataProxy, data).then(res => {
                    this.loading = false
                    if (res.data.code === '200') {
                        let responseData = res.data.data

                        if (responseData.resultType === 'pdf') {
                            // this.pdfSrc = pdf.createLoadingTask({url: responseData.value, CMapReaderFactory});
                            // this.pdfSrc.promise.then(pdf => {
                            //     this.pdfPage = pdf.numPages;
                            // });
                            this.downloadFile(this.name + '.pdf', responseData.value);
                        }

                        if (responseData.resultType === 'docx') {
                            this.downloadFile(this.name + '.docx', responseData.value);
                        }


                        this.resultObj = res.data.data
                        this.isClick = 0
                    } else {
                        this.isClick = 0
                        this.$message.error(res.data.message)
                    }
                })
            },
            downloadFile(fileName, content) {
                let aLink = document.createElement('a');
                let blob = this.base64ToBlob(content); //new Blob([content]);

                let evt = document.createEvent("HTMLEvents");
                console.log("点击下载", evt)
                evt.initEvent("click", true, true);//initEvent 不加后两个参数在FF下会报错  事件类型，是否冒泡，是否阻止浏览器的默认行为
                aLink.download = fileName;
                aLink.href = URL.createObjectURL(blob);

                // aLink.dispatchEvent(evt);
                aLink.click()
            },
            //base64转blob
            base64ToBlob(code) {
                let parts = code.split(';base64,');
                let contentType = parts[0].split(':')[1];
                let raw = window.atob(parts[1]);
                let rawLength = raw.length;

                let uInt8Array = new Uint8Array(rawLength);

                for (let i = 0; i < rawLength; ++i) {
                    uInt8Array[i] = raw.charCodeAt(i);
                }
                return new Blob([uInt8Array], {type: contentType});
            },

            getCityList() {
                let data = {}
                this.$http.get(url.addressMenuAddr, {
                    params: data
                }).then(res => {
                    if (res.data.code === '200') {
                        this.cityList = res.data.data
                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },
            getQuery() {
                let data = {
                    menuId: this.id
                }
                this.$http.get(url.onlineModuleMenuInfo, {
                    params: data
                }).then(res => {
                    if (res.data.code === '200') {
                        //
                        this.queryList = res.data.data


                        // res.data.data.forEach(res => {
                        //     if (res === 'city') {
                        //         this.queryParams[res] = []
                        //     }
                        // })


                    } else {
                        this.$message.error(res.data.message)
                    }
                })
            },

            handleOpenDetail() {
                this.dialogVisible = true
                // this.getInfo()
            },
            submitForm() {
                this.$refs['timingForm'].validate((valid) => {
                    if (valid) {


                        let data = this.queryParams

                        let timingForm = this.timingForm
                        for (var key in timingForm) {
                            if (timingForm.hasOwnProperty(key) === true) {
                                data[key] = timingForm[key];
                            }
                        }

                        data.menuId = this.id


                        // if (data.id) {
                        //     this.$http.post(url.wordTaskupdate, data).then(res => {
                        //         if (res.data.code === '200') {
                        //             this.$message.success('修改定时任务成功')
                        //             this.dialogVisible = false
                        //         } else {
                        //             this.$message.error(res.data.message)
                        //         }
                        //     })
                        // } else {
                        this.$http.post(url.wordTaskSaveApi, data).then(res => {
                            if (res.data.code === '200') {
                                this.$message.success('增加定时任务成功')
                                this.dialogVisible = false
                            } else {
                                this.$message.error(res.data.message)
                            }
                        })
                        // }

                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        },
        beforeRouteUpdate(to, from, next) {
            //     路由切换
            //     初始化页面
            next()
            this.init()
        },
    }
</script>

<style scoped lang="less">
    @import "../../assets/vocContent";

    .VOCNavBar {
        overflow: hidden;
        .BarList {
            flex: 1;
            overflow: auto;
        }
    }

    .VOCContent {
        text-align: center;
        img {
            max-width: 100%;
            /*width: 100px;*/
            /*height: 100px;*/
        }
    }

    .VOCContentPdf {
        padding: 0 20px;
    }
</style>
